import { useTranslation } from 'i18n';
import { Alert, formatNumber } from 'ui';

export interface TotalWeightWarningProps {
  totalWeight: number | null;
  breakdownValues: Array<{ value: number | string }>;
}

export const TotalWeightWarning = ({ totalWeight, breakdownValues }: TotalWeightWarningProps) => {
  const { t } = useTranslation('features');
  const rawSum = breakdownValues?.reduce((acc, curr) => acc + Number(curr.value), 0) || 0;

  const roundedSum = Math.round(rawSum * 100) / 100;
  const roundedTotalWeight = Math.round(Number(totalWeight || 0) * 100) / 100;

  const showWarning = roundedSum !== roundedTotalWeight;

  if (!showWarning) {
    return null;
  }

  const formattedSum = formatNumber(rawSum, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
  const formattedTotalWeight = formatNumber(Number(totalWeight || 0), {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  return (
    <Alert severity="warning">
      {t('backlog.breakdowns.totalWeightWarning.message', {
        values: {
          formattedSum,
          formattedTotalWeight,
        },
      })}
    </Alert>
  );
};
